<ax-snackbar
  [open]="this.errorType !== ErrorType.NONE && this.errorType !== ErrorType.LOGIN_NOT_VERIFIED"
  [dismissible]="false"
  color="red"
>
  {{ errorText | translate }}
</ax-snackbar>
